import React from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, LogOut } from "lucide-react";
import { useDispatch } from "react-redux";
import { setLogout } from "../../redux/slices/authSlice";

const Unauthorized = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(setLogout());
    navigate("/login");
  };

  return (
    <Container
      className="d-flex flex-column align-items-center justify-content-center text-center"
      style={{ minHeight: "100vh" }}
    >
      <ShieldAlert size={100} className="text-danger mb-4" />
      <h1 className="fw-bold text-dark mb-2">Access Denied</h1>
      <p className="text-muted mb-4 fs-5" style={{ maxWidth: "500px" }}>
        You do not have the necessary permissions to access this page. Your
        current account role does not permit access to the Admin Panel.
      </p>
      <div className="d-flex gap-3">
        <Button variant="outline-primary" onClick={() => navigate("/")}>
          Return Home
        </Button>
        <Button
          variant="danger"
          onClick={handleLogout}
          className="d-flex align-items-center gap-2"
        >
          <LogOut size={18} /> Logout & Switch Account
        </Button>
      </div>
    </Container>
  );
};

export default Unauthorized;
